// extracted by mini-css-extract-plugin
module.exports = {"changelog-container":"changelog_changelog-container__2_U6p","changelog-list-container":"changelog_changelog-list-container__1sdf4"};